/**
 * Pure grading helpers that translate an exercise interaction into a
 * spaced-repetition {@link Grade}.
 */
import type { Grade } from "@repo/hindi-shared";

/**
 * Map the number of attempts a learner needed on a multiple-choice pick to a
 * {@link Grade}: first try → Good (2), second try → Hard (1), third or
 * later → Again (0).
 */
export function gradeFromChoice(attempts: number): Grade {
  if (attempts <= 1) return 2;
  if (attempts === 2) return 1;
  return 0;
}

/** Map a learner's self-assessed correct/incorrect mark to a {@link Grade}. */
export function gradeFromSelfMark(ok: boolean): Grade {
  return ok ? 2 : 0;
}
